module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.error) ? _c('div', [_c('p', [_vm._v("There was an error loading the map request form. Please contact us if this issue persists.")])]) : _vm._e(), _vm._v(" "), (!_vm.loaded) ? _c('div', [_c('p', [_vm._v("Loading available reports.")])]) : _c('div', [_vm._l((_vm.responseMessages), function(responseMessage, index) {
    return (_vm.responseReceived) ? _c('div', [(responseMessage.success) ? _c('div', [_vm._m(0, true)]) : _c('div', [_c('div', {
      staticClass: "warn"
    }, [_c('div', {
      staticClass: "message alert alert-warning mb-4 mt-4"
    }, [(responseMessage.location) ? _c('p', [_vm._v("Location: " + _vm._s(responseMessage.location))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(responseMessage.statusMessage))]), _vm._v(" "), _vm._l((_vm.requestedReports), function(reportRequest) {
      return [_vm._v("\n                            " + _vm._s(reportRequest) + "\n                        ")]
    }), _vm._v(" "), (responseMessage.outputMessages.length > 0) ? [_c('p', [_vm._v("Details:")]), _vm._v(" "), _c('ul', _vm._l((responseMessage.outputMessages), function(outputMessage) {
      return _c('li', [_vm._v(_vm._s(outputMessage))])
    }), 0)] : _vm._e()], 2)])])]) : _vm._e()
  }), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', [_c('div', {
    staticClass: "warn"
  }, [_c('div', {
    staticClass: "message alert alert-warning mb-4 mt-4"
  }, [_c('p', [_vm._v("Your request has the following error(s):")]), _vm._v(" "), _c('ul', _vm._l((_vm.formErrors), function(formError) {
    return _c('li', [_vm._v(_vm._s(formError))])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (!_vm.error) ? _c('form', {
    attrs: {
      "id": "vm-req-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Select up to 10 properties per map type:")]), _vm._v(" "), _vm._l((_vm.reportsAvailable), function(reports) {
    return _c('div', [_c('div', {
      staticClass: "form-check checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.requestedReports),
        expression: "requestedReports",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-check-input",
      attrs: {
        "id": reports.key,
        "type": "checkbox",
        "name": "report-types"
      },
      domProps: {
        "value": reports.key,
        "checked": Array.isArray(_vm.requestedReports) ? _vm._i(_vm.requestedReports, reports.key) > -1 : (_vm.requestedReports)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.requestedReports,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = reports.key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.requestedReports = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.requestedReports = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.requestedReports = $$c
          }
        }, function($event) {
          return _vm.requestType()
        }]
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": reports.key
      }
    }, [_vm._v(_vm._s(reports.name)), _c('br'), _c('small', [_vm._v(_vm._s(reports.description))])])])])
  })], 2), _vm._v(" "), (_vm.locationTypeSelector) ? _c('div', {
    staticClass: "mb-1"
  }, [_c('fieldset', [_c('legend', [_vm._v("Specify map location by")]), _vm._v(" "), _c('div', {
    staticClass: "form-check radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.locationType),
      expression: "locationType",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "point",
      "type": "radio",
      "name": "location-types",
      "value": "point"
    },
    domProps: {
      "checked": _vm._q(_vm.locationType, "point")
    },
    on: {
      "change": function($event) {
        _vm.locationType = "point"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "point"
    }
  }, [_vm._v("Coordinates")])]), _vm._v(" "), _c('div', {
    staticClass: "form-check radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.locationType),
      expression: "locationType",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-check-input",
    attrs: {
      "id": "lot-plan",
      "type": "radio",
      "name": "location-types",
      "value": "LotPlan"
    },
    domProps: {
      "checked": _vm._q(_vm.locationType, "LotPlan")
    },
    on: {
      "change": function($event) {
        _vm.locationType = "LotPlan"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "lot-plan"
    }
  }, [_vm._v("Lot/plan")])])])]) : _vm._e(), _vm._v(" "), (_vm.locationType === 'LotPlan' && _vm.requestedReports.length > 0) ? _c('div', [_c('hr'), _vm._v(" "), _c('fieldset', [_vm._l((_vm.lotPlans), function(lotPlan, index) {
    return _c('div', {
      staticClass: "lot-plan d-flex gap-4 mb-4"
    }, [_c('div', {
      staticClass: "row w-100"
    }, [_c('div', {
      staticClass: "group lot col-6 d-flex flex-column justify-content-between"
    }, [_c('div', {
      staticClass: "mb-0"
    }, [_c('label', {
      staticClass: "qld-text-input-label field-required",
      attrs: {
        "for": 'lot-number-' + index
      }
    }, [_vm._v("Lot number")]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (lotPlan.lot),
        expression: "lotPlan.lot",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "lotNumber form-control",
      attrs: {
        "type": "text",
        "required": "",
        "name": "lot-number",
        "id": 'lot-number-' + index,
        "autocomplete": "off"
      },
      domProps: {
        "value": (lotPlan.lot)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(lotPlan, "lot", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "group plan col-6 d-flex flex-column justify-content-between"
    }, [_c('div', {
      staticClass: "mb-0"
    }, [_c('label', {
      staticClass: "qld-text-input-label field-required",
      attrs: {
        "for": 'plan-number-' + index
      }
    }, [_vm._v("Plan number")]), _vm._v(" "), _vm._m(2, true)]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (lotPlan.plan),
        expression: "lotPlan.plan",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "planNumber form-control",
      attrs: {
        "type": "text",
        "required": "",
        "name": "plan-number",
        "id": 'plan-number-' + index,
        "autocomplete": "off"
      },
      domProps: {
        "value": (lotPlan.plan)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(lotPlan, "plan", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "align-self-end"
    }, [(_vm.lotPlans[0].lot !== '' && _vm.lotPlans[0].plan) ? _c('button', {
      staticClass: "close btn btn-secondary",
      staticStyle: {
        "min-width": "10%"
      },
      attrs: {
        "id": "remove-lotplan",
        "type": "button",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          return _vm.removeLotPlan(index)
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])]) : _vm._e()])])
  }), _vm._v(" "), (_vm.lotPlans[0].lot !== '' && _vm.lotPlans[0].plan) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "id": "add-lotplan",
      "type": "button"
    },
    on: {
      "click": _vm.addLotPlan
    }
  }, [_vm._v("Add another location")]) : _vm._e(), _vm._v(" "), _vm._m(3)], 2)]) : _vm._e(), _vm._v(" "), (_vm.locationType === 'point' && _vm.requestedReports.length > 0) ? _c('div', [_c('hr'), _vm._v(" "), _c('fieldset', [_vm._l((_vm.coordinates), function(point, index) {
    return _c('div', {
      staticClass: "coordinates d-flex gap-4 mb-4"
    }, [_c('div', {
      staticClass: "row w-100"
    }, [_c('div', {
      staticClass: "group lat col-6 d-flex flex-column justify-content-between"
    }, [_c('div', {
      staticClass: "mb-0"
    }, [_c('label', {
      staticClass: "qld-text-input-label field-required",
      attrs: {
        "for": 'lat-' + index
      }
    }, [_vm._v("Latitude")]), _vm._v(" "), _c('span', {
      staticClass: "qld-hint-text"
    }, [_vm._v("In decimal degrees, e.g. -17.286001")])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (point.lat),
        expression: "point.lat",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "latNumber form-control",
      attrs: {
        "type": "text",
        "required": "",
        "name": "lat",
        "id": 'lat-' + index,
        "autocomplete": "off"
      },
      domProps: {
        "value": (point.lat)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(point, "lat", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "group lng col-6 d-flex flex-column justify-content-between"
    }, [_c('div', {
      staticClass: "mb-0"
    }, [_c('label', {
      staticClass: "qld-text-input-label field-required",
      attrs: {
        "for": 'lng-' + index
      }
    }, [_vm._v("Longitude")]), _vm._v(" "), _c('span', {
      staticClass: "qld-hint-text"
    }, [_vm._v("In decimal degrees, e.g. 145.573891")])]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (point.lng),
        expression: "point.lng",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "lngNumber form-control",
      attrs: {
        "type": "text",
        "required": "",
        "name": "lng",
        "id": 'lng-' + index,
        "autocomplete": "off"
      },
      domProps: {
        "value": (point.lng)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(point, "lng", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "align-self-end"
    }, [(_vm.coordinates[0].lat !== '' && _vm.coordinates[0].lng) ? _c('button', {
      staticClass: "close btn btn-secondary",
      staticStyle: {
        "min-width": "10%"
      },
      attrs: {
        "id": "remove-coordinates",
        "type": "button",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          return _vm.removeCoordinates(index)
        }
      }
    }, [_c('span', {
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])]) : _vm._e()])])
  }), _vm._v(" "), (_vm.coordinates[0].lat !== '' && _vm.coordinates[0].lng) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "id": "add-coordinates",
      "type": "button"
    },
    on: {
      "click": _vm.addCoordinates
    }
  }, [_vm._v("Add another location\n                    ")]) : _vm._e(), _vm._v(" "), _vm._m(4)], 2)]) : _vm._e(), _vm._v(" "), (_vm.requestedReports.length > 0 && (_vm.lotPlans[0].lot !== '' && _vm.lotPlans[0].plan !== '' || _vm.coordinates[0].lat !== '' && _vm.coordinates[0].lng !== '')) ? _c('div', [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "email mt-4 mb-4"
  }, [_c('label', {
    staticClass: "qld-text-input-label field-required",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.emailAddress),
      expression: "emailAddress",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "emailAddress form-control",
    attrs: {
      "type": "email",
      "required": "",
      "name": "email",
      "id": "email",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('strong', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.requestMap()
      }
    }
  }, [_vm._v("Request map")])])]) : _vm._e()]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success"
  }, [_c('div', {
    staticClass: "message alert alert-success mb-4 mt-4"
  }, [_c('div', [_c('p', [_vm._v("Request sent! You should receive your report shortly. If not received, check your spam folder. Please note sometimes technical difficulties may delay the delivery of your report. If you haven't received your report after 24 hours, please contact "), _c('a', {
    attrs: {
      "href": "https://www.nrmmrrd.qld.gov.au/contact-us#vegetation-management"
    }
  }, [_vm._v("support")]), _vm._v(".")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "qld-hint-text"
  }, [_vm._v("Enter the lot only, do not include L or lot in front. "), _c('br'), _vm._v("\n                                (e.g. 57 or D)\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "qld-hint-text"
  }, [_vm._v("Enter the plan only. "), _c('br'), _vm._v("(e.g. RP2 or AG1234)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-danger mt-3",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hide-lotplan-alert"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("Enter at least one set of lot on plan details or coordinates")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-danger mt-3",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "hide-coordinates-alert"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("Enter at least one set of lot on plan details or coordinates")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d703e91c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 38
// module chunks = 0